<div class="text-bidit-primary">
  <div class="row mb-3">
    <div class="col-6 quote-header">
      <span>Change Order:</span> {{changeOrder.changeOrder_Name}}
      <button class="ml-3 btn btn-bidit-edit" (click)="openEditDialog()" title="Edit title"></button>
    </div>
    <div class="col-6 quote-header">
      <span>Comments:</span> {{changeOrder.changeOrder_Comments}}
    </div>
    <div class="form-inline float-right" *ngIf="this.changeOrderAcknowlegement?.acknowledgementStatusDesc">
      <div class="mr-3"><span class="col-form-label" i18n>Acknowledgement Status: </span> {{this.changeOrderAcknowlegement?.acknowledgementStatusDesc}}</div>
      <div *ngIf="this.changeOrderAcknowlegement?.acknowledgedDate">
        <span class="col-form-label" i18n>Acknowledgement Date: </span><span class="mr-5"> {{this.changeOrderAcknowlegement?.acceptedQuoteRejectedDate ?? this.changeOrderAcknowlegement?.acknowledgedDate | date:'MM/dd/yyyy'}}</span>
      </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-6">
      <button *ngIf="!readOnly" class=" float-left btn btn-bidit-submit float-left" (click)="openAreaDialog(null)" i18n>Add Item</button>
    </div>
    <div class="col-6">
      <button *ngIf="canApprove && !this.changeOrder.changeOrder_Approved" (click)="approveChangeOrder()" class=" float-right btn btn-bidit-submit btn-md" i18n>Approve Change Order</button>
    </div>
  </div>

  <div class="text-bidit-primary mb-5" *ngFor="let area of areaSummaries">
    <div class="row">
      <h5 class="col">
        {{area.area_Name}}
      </h5>
      <div class="float-right mr-5">
        <div colspan="5"></div>
        <div><h5><span i18n>Total</span> ${{area.totalCost | number: '1.2-2'}}</h5></div>
      </div>
    </div>
    <mat-accordion>
      <div class="text-bidit-primary" *ngFor="let quoteArea of area.quoteAreas">
        <mat-expansion-panel *ngIf="quoteArea.acceptedItem">
          <mat-expansion-panel-header [ngClass]="{ 'change-row': quoteArea.changeOrderItem}">
            <div class="col-6">
              <div>
                {{quoteArea.acceptedItem.subArea.subArea_Name}}
                <span *ngIf="quoteArea.acceptedItem.area_Name">- ({{quoteArea.acceptedItem.area_Name}})</span>
              </div>

              <div *ngIf="quoteArea.changeOrderItem" class="alert">
                <div *ngIf="quoteArea.changeOrderItem.changeOrderItem_IsDelete; else modifiedBlock" i18n>
                  REMOVED
                </div>
                <ng-template #modifiedBlock i18n>
                  MODIFIED
                </ng-template>
              </div>
            </div>
            <div *ngFor="let workOrder of quoteArea.workOrders" class="col-6">
              <span i18n>WORK ORDER</span> - #{{workOrder.workOrder_Seq}} - {{workOrder.workOrder_Start | date: 'M/d/yyyy'}} - {{workOrder.workOrder_Stop | date: 'M/d/yyyy'}}
            </div>
            <div class="col-6" *ngIf="quoteArea.changeOrderItem; else unmodifiedArea">
              <div class="col">
                <label i18n>Square Ftg Adj:</label>
                <span>{{quoteArea.changeOrderItem.changeOrderItem_SqrFtgAdjustment | number: '1.0' }}</span>
              </div>
              <div class="col">
                <label i18n>Cost Change:</label>
                <span>${{quoteArea.changeOrderItem.changeOrderItem_TotalCost | number: '1.2' }}</span>
              </div>
            </div>
            <ng-template #unmodifiedArea>
              <div class="col-6">
                <div class="col">
                  <label i18n>Square Ftg:</label>
                  <span>{{quoteArea.acceptedItem.area_SqrFtg | number: '1.0' }}</span>
                </div>
                <div class="col">
                  <label *ngIf="area.area_IsOption; else defaultHeader" i18n>Cost Change:</label>
                  <ng-template>
                    <label i18n>Cost:</label>
                  </ng-template>
                  <span>${{quoteArea.acceptedItem.area_TotalCost | number: '1.2' }}</span>
                </div>
              </div>
            </ng-template>
          </mat-expansion-panel-header>
          <div class="row mt-3" *ngIf="quoteArea.acceptedItem.item">
            <div class="col-md-6">
              <span *ngIf="quoteArea.acceptedItem.item">
                <span *ngIf="quoteArea.acceptedItem.item.item_Part">{{quoteArea.acceptedItem.item.item_Part}},</span>
                {{quoteArea.acceptedItem.item.item_Name}}

                <div *ngIf="quoteArea.changeOrderItem && quoteArea.acceptedItem.item_ID != quoteArea.changeOrderItem.item_ID" class="alert">
                  <span *ngIf="quoteArea.changeOrderItem.item.item_Part">{{quoteArea.changeOrderItem.item.item_Part}},</span>
                  {{quoteArea.changeOrderItem.item.item_Name}}
                </div>
              </span>
              <span *ngIf="quoteArea.acceptedItem.item">
                {{quoteArea.acceptedItem.area_Note}}
              </span>
            </div>
            <div class="col-md-6">
              <div class="col" *ngIf="quoteArea.acceptedItem.item">
                <label class="mr-2">R-Value: </label>
                <span *ngIf="quoteArea.acceptedItem.itemUsage; then usageBlock; else rValueBlock"></span>
                <ng-template #usageBlock>{{quoteArea.acceptedItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                <ng-template #rValueBlock>
                  <span *ngIf="quoteArea.acceptedItem.item?.rValue">{{quoteArea.acceptedItem.item.rValue.rValue_Desc}}</span>
                </ng-template>
              </div>
              <div class="col">
                <div *ngIf="area.area_IsOption; else defaultAccessoryBlock">
                  <label class="mr-2" i18n>Estimate Change:</label>
                  <span>
                    ${{quoteArea.acceptedItem.optionBid | number: '1.2' }}
                  </span>
                </div>
                <ng-template #defaultAccessoryBlock>
                  <label class="mr-2" i18n>Addl Items:</label>
                  <span>
                    {{quoteArea.acceptedItem.accessories.length}}
                  </span>
                </ng-template>
              </div>
            </div>
            <div class="col-md-6" *ngIf="quoteArea.changeOrderItem">
              <div class="col">
                <label class="mr-2" i18n>Sqr Ftg Orig: </label>
                <span>{{quoteArea.acceptedItem.area_SqrFtg | number: '1.0'}}</span>
              </div>
              <div class="col">
                <label class="mr-2" i18n>Price Orig:</label>
                <span>${{quoteArea.acceptedItem.area_TotalCost | number: '1.2'}}</span>
              </div>
              <div class="col">
                <label class="mr-2" i18n>Sqr Ftg Adj:</label>
                <span>{{quoteArea.changeOrderItem.changeOrderItem_SqrFtgAdjustment | number: '1.0'}}</span>
              </div>
              <div class="col">
                <label class="mr-2" i18n>Price Adj:</label>
                <span>${{quoteArea.changeOrderItem.changeOrderItem_TotalCost | number: '1.2'}}</span>
              </div>
              <div class="col">
                <label class="mr-2" i18n>Sqr Ftg Net:</label>
                <span>${{quoteArea.acceptedItem.area_SqrFtg + quoteArea.changeOrderItem.changeOrderItem_SqrFtgAdjustment | number: '1.0'}}</span>
              </div>
              <div class="col">
                <label class="mr-2" i18n>Net Price:</label>
                <span>${{quoteArea.acceptedItem.area_TotalCost + quoteArea.changeOrderItem.changeOrderItem_TotalCost | number: '1.2'}}</span>
              </div>
            </div>

          </div>
          <mat-action-row class="float-right mb-3">
            <div *ngIf="!readOnly">
              <div *ngIf="quoteArea.changeOrderItem; else unmodifiedButtons">
                <button class="btn btn-bidit-navigate" (click)="revertChangeOrder(quoteArea.changeOrderItem.changeOrderItem_ID)" title="Revert Change" i18n>Undo Change</button>
                <button class="ml-1 btn btn-bidit-edit" (click)="openAreaDialog(quoteArea, quoteArea.changeOrderItem.changeOrderItem_ID)" title="Edit"></button>
              </div>
              <ng-template #unmodifiedButtons>
                <button class="mb-1 mr-1 btn btn-bidit-navigate" (click)="openAreaDialog(quoteArea, null)" title="Change Item" i18n>Change Item</button>
                <button class="mb-1 btn btn-bidit-navigate" (click)="deleteArea(quoteArea.acceptedItem)" title="Cancel Item" i18n>Cancel Item</button>
                <button class="ml-1 btn btn-bidit-edit" (click)="openAreaDialog(quoteArea, quoteArea.changeOrderItem.changeOrderItem_ID)" title="Edit"></button>
              </ng-template>
            </div>
          </mat-action-row>
        </mat-expansion-panel>
      </div>

      <div class="text-bidit-primary" *ngFor="let newItem of area.newItems">
        <mat-expansion-panel>
          <mat-expansion-panel-header class="change-row">
            <div class="col-6">
              <div>
                {{newItem.subArea.subArea_Name}}
                <span *ngIf="newItem.changeOrderItem_Name">
                  - ({{newItem.changeOrderItem_Name}})
                </span>
              </div>
              <div class="alert" i18n>NEW</div>
            </div>
            <div class="col-6">
              <div class="col">
                <label i18n>Square Ftg:</label>
                <span>{{newItem.changeOrderItem_SqrFtgAdjustment | number: '1.0' }}</span>
              </div>
              <div class="col">
                <label *ngIf="area.area_IsOption; else defaultHeader" i18n>Cost Change:</label>
                <ng-template>
                  <label i18n>Cost:</label>
                </ng-template>
                <span>${{newItem.changeOrderItem_TotalCost | number: '1.2' }}</span>
              </div>
            </div>
          </mat-expansion-panel-header>
          <div class="row mt-3">
            <div class="col-md-6">
              <span i18n>NEW ITEM</span> -
              <span *ngIf="newItem.changeOrderItem_IsCustomItem">
                {{newItem.changeOrderItem_Note}}
              </span>
              <span *ngIf="newItem.item">
                <span *ngIf="newItem.item.item_Part">{{newItem.item.item_Part}},</span>
                {{newItem.item.item_Name}}
              </span>
            </div>
            <div class="col-md-6">
              <div class="col" *ngIf="newItem.item">
                <label class="mr-2" i18n>R-Value:</label>
                <span *ngIf="newItem.itemUsage; then usageBlock; else rValueBlock"></span>
                <ng-template #usageBlock>{{newItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                <ng-template #rValueBlock>
                  <span *ngIf="newItem.item.rValue">{{newItem.item.rValue.rValue_Desc}}</span>
                </ng-template>
              </div>
              <div class="col">
                <div *ngIf="area.area_IsOption; else defaultAccessoryBlock">
                  <label class="mr-2" i18n>Estimate Change:</label>
                  <span>
                    ${{newItem.optionBid | number: '1.2' }}
                  </span>
                </div>
                <ng-template #defaultAccessoryBlock>
                  <label class="mr-2" i18n>Addl Items:</label>
                  <span>
                    {{newItem.accessories.length}}
                  </span>
                </ng-template>
              </div>
              <div class="col-md-6">
                <div class="col">
                  <label class="mr-2" i18n>Sqr Ftg Net:</label>
                  <span>${{newItem.changeOrderItem_SqrFtgAdjustment | number: '1.0'}}</span>
                </div>
                <div class="col">
                  <label class="mr-2" i18n>Net Price:</label>
                  <span>${{newItem.changeOrderItem_TotalCost | number: '1.2'}}</span>
                </div>
              </div>
            </div>

          </div>
          <mat-action-row class="float-right mb-3">
            <div *ngIf="!readOnly">
              <button class="btn btn-bidit-navigate" (click)="revertChangeOrder(newItem.changeOrderItem_ID)" title="Revert Change" i18n>Undo Change</button>
              <button class="ml-3 btn btn-bidit-edit" (click)="openAreaDialog(area, newItem.changeOrderItem_ID)" title="Edit"></button>
            </div>
          </mat-action-row>
        </mat-expansion-panel>
      </div>
    </mat-accordion>
  </div>

  <div class="col">
    <div class="cost-breakdown-pnl">
      <h5 align="center">COST BREAKDOWN</h5>
      <table class="table table-bidit">
        <tbody>
          <tr>
            <td i18n>Material Cost:</td>
            <td>${{changeOrder.materialCost | number: '1.2'}} ({{100 * changeOrder.materialCost / changeOrder.totalCost | number: '1.2-2'}}%)</td>
          </tr>
          <tr>
            <td i18n>Labor Cost:</td>
            <td>${{changeOrder.laborCost | number: '1.2'}} ({{100 * changeOrder.laborCost / changeOrder.totalCost | number: '1.2-2'}}%)</td>
          </tr>
          <tr>
            <td i18n>Other Cost:</td>
            <td>${{changeOrder.otherCost | number: '1.2'}} ({{100 * changeOrder.otherCost / changeOrder.totalCost | number: '1.2-2'}}%)</td>
          </tr>
          <tr>
            <td i18n>Total Cost:</td>
            <td>${{changeOrder.totalCost | number: '1.2'}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="estimate-pnl">
      <h5 align="center" i18n>ESTIMATE</h5>
      <table class="table table-bidit">
        <tbody>
          <tr>
            <td i18n>Total Cost:</td>
            <td>${{changeOrder.totalCost | number: '1.2'}}</td>
          </tr>
          <tr>
            <td i18n>Gross Margin:</td>
            <td>
              <div *ngIf="showMarginEdit==false">
                <a *ngIf="!readOnly" class="float-left" href="javascript:void(0);" (click)="editMargin()" i18n>Edit</a>

                <span class="float-right">{{changeOrder.changeOrder_GrossMargin | number: '1.0-4'}}%</span>
              </div>
              <div *ngIf="showMarginEdit" class="form-group">
                <div class="input-group-prepend">
                  <button class="btn btn-outline-danger form-control" (click)="updateQuoteMargin()" i18n>Update</button>
                </div>
                <input name="changeOrder_GrossMargin" type="number" id="changeOrder_GrossMargin" class="form-control"
                       [(ngModel)]="changeOrder.changeOrder_GrossMargin" #changeOrder_GrossMargin="ngModel" />
              </div>
            </td>
          </tr>
          <tr>
            <td i18n>Bid Subtotal:</td>
            <td>
              <div *ngIf="showBidAmountEdit==false">
                <a *ngIf="!readOnly" href="javascript:void(0);" (click)="editBid()" i18n>Edit</a>
                <span class="float-right">${{changeOrder.changeOrder_BidAmount | number: '1.2-2'}}</span>
              </div>

              <div *ngIf="showBidAmountEdit" class="input-group input-group-sm">
                <div class="input-group-prepend">
                  <button class="btn btn-outline-danger form-control" name="editAmount" value="editAmount" (click)="updateBidAmount()" i18n>Update</button>
                </div>
                <input name="changeOrder_BidAmount" id="changeOrder_BidAmount" type="text" class="form-control"
                       style="text-align:right;"
                       [(ngModel)]="changeOrder.changeOrder_BidAmount" #changeOrder_BidAmount="ngModel">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <button *ngIf="!readOnly" (click)="openTaxDialog()" class="btn btn-bidit-navigate btn-md" i18n>Edit Tax</button>
              <label *ngIf="readOnly" i18n>Tax Amount:</label>
            </td>
            <td>${{changeOrder.netTax_Total | number: '1.2-2'}}</td>
          </tr>
          <tr>
            <td i18n>Bid Amount:</td>
            <td>${{changeOrderTotalBidAmount | number: '1.2-2'}}</td>
          </tr>
          <tr>
            <td i18n>Margin Dollars:</td>
            <td>${{changeOrderMarginAmount | number: '1.2-2'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


  <app-spinner [isRunning]="isRequesting"></app-spinner>
</div>

<div class="row" align="center">
  <div class="col-12" *ngIf="!isRequesting">
    <button (click)="printQuote()" class="btn btn-bidit-action mr-1" i18n>Print</button>
    <button (click)="openEmailDialog()" class="btn btn-bidit-action" i18n>Send</button>
    <button (click)="acknowledgeChangeOrder(2)" *ngIf="!isRequesting && this.changeOrderAcknowlegement?.acknowledgementStatusDesc == 'Pending' || this.changeOrderAcknowlegement?.acknowledgementStatusDesc == 'Accepted'" class="ml-1 btn btn-bidit-action" onclick="this.blur();" i18n>Reject</button>
  </div>
  <app-spinner [isRunning]="isRequesting"></app-spinner>
</div>
<div class="row">
  <div class=" col-sm-9">
    <button (click)="returnToList()" class="btn btn-bidit-submit float-right" i18n>Back</button>
  </div>
</div>

